
import g from '@/model/language'
import { IsRights, Modulel, Permission, Clone, ToComponentData, ToSubmitEntity, CheckByConfig, ToSubmitData, CheckByEntity } from '@/config/config'
import { userRequest } from '@/request/user'
import { departmentSearchRequest } from '@/request/Department'
import { RoleRequest } from '@/request/RoleRequest'
import '@/lf'



export var LoginPage = [
    { nickName: g('$登录名'), field: 'LoginName', type: 'String', initValue: '', isRequired: true, j: { rex: 'w', tips: g('${登录名}为必填') } },
    { nickName: g('$密码'), field: 'Password', isRequired: true, j: { rex: 'w', tips: g('${密码}为必填') } },
]



var dc = { data: {} };

export var UserManagePage = {
    Title: g('$用户管理'),
    storeName: 'UserManagePage',
    IsInit: false,
    Search: //page-search-table 配置
        [
            { nickName: g('$登录名'), field: 'LoginName', type: 'String', initValue: '' },
            { nickName: g('$状态'), field: 'Status', type: 'Select', forSelectStoreName: 'UserStatus', initValue: 1 },
            { nickName: g('$姓名'), field: 'Name', type: 'String' },
            { nickName: g('$手机'), field: 'PhoneNumber', type: 'String' },
        ],
    SearchEntity: {
    },
    /**
     * 配置参考 config.js 的 TableDefaultConfig 和 TableColumnDefaultConfig
     */
    Table: {
        OnSelectionChange: function (selection) {
            window.rootVue.$set(window.rootVue.$store.state, ('UserManagePageTableSelectCheckbox'), selection)
        },
        TableColumns: [
            { nickName: ' ', field: '', type: 'selection', Width: 50, fixed: 'left', initValue: false, forSelectStoreName: ('UserManagePageTableSelectCheckbox') },
            { nickName: g('$用户类型'), field: 'UserType', type: 'Select', forSelectStoreName: 'UserType' },
            { nickName: g('$状态'), field: 'Status', type: 'Select', forSelectStoreName: 'UserStatus' },
            { nickName: g('$登录名'), field: 'LoginName', type: 'String', initValue: '' },
            { nickName: g('$姓名'), field: 'FirstName,LastName', type: 'AddString', initValue: '' },
            { nickName: g('$Email'), field: 'Email', type: 'String', initValue: '' },
            { nickName: g('$性别'), field: 'Gender', type: 'Select', initValue: '', forSelectStoreName: 'UserGender' },
            { nickName: g('$生日'), field: 'Birthday', type: 'DateTime', initValue: '' },
            { nickName: g('$手机'), field: 'PhoneNumber', type: 'String', initValue: '' },
            { nickName: g('$部门'), field: 'Department.Name', type: 'AddString', initValue: '' ,
                    // AddString(data) {
                    //     return data.Department.Name
                    // }
            },
            { nickName: g('$操作'), field: 'ID', type: 'Operation', initValue: '', Width: 300, Fixed: 'right', ClassName: 'FixedRightBorder' },
        ],

        TableRowButtons: function (config) { //列表按钮
            var store = UserManagePage.getThisStore()
            if (store.Table.$TableRowButtons) {
                return store.Table.$TableRowButtons
            }

            var arr = [];
            if (IsRights(Modulel.UserManage, Permission.Update)) {

                arr.push({
                    nickName: g('$修改'), buttonType: 'primary', type: 'Button', forClick: function (data) {
                      
                        userRequest.GetUser(function (d) {
                            var f = new window.$LQ(store.FieldData).Where(function (a) { return a.field == 'Password' }).First()
                            f.type = "Hide"
                            f.j = null;                           
                            store.AddModuleShow = true;
                            store.ModalName = g('$修改用户')
                            store.AddModalName = g('$修改用户')
                            window.rootVue.$set(store, 'Entity', d)
                        }, data.ID)
                    }
                })

            } else if (IsRights(Modulel.UserManage, Permission.See)) {
                arr.push({
                    nickName: g('$查看'), buttonType: 'primary', type: 'Button', forClick: function (data) {
                        userRequest.GetUser(function (d) {
                            var f = new window.$LQ(store.FieldData).Where(function (a) { return a.field == 'Password' }).First()
                            f.type = "Hide"
                            f.j = null;
                            window.rootVue.$set(store, 'Entity', d)
                            store.AddModuleShow = true;
                            store.ModalName = g('$查看用户')
                        }, data.ID)
                    }
                })
            }
            if (IsRights(Modulel.UserManage, Permission.UpdateStatus)) {
                arr.push({
                    nickName: g('$设置禁用'), buttonType: 'warning', type: 'ButtonCheckShow', CheckShow: function (data) {
                        // console.log(data)
                        if (data.Status == 1) {
                            return true;
                        }
                        return false;
                    }, forClick: function (data) {
                        userRequest.SetUserStatus(function (d) {
                            if (d.Message == "OK") {
                                store.Table.OnPageChange(store.SearchEntity.PageIndex, window.rootVue)
                                window.rootVue.$message.success(g("$操作成功"))
                            } else {
                                window.rootVue.$message.error(d.Message)
                            }
                        }, data.ID, 2)
                    }
                })

                arr.push({
                    nickName: g('$设置启用'), buttonType: 'warning', type: 'ButtonCheckShow', CheckShow: function (data) {
                        if (data.Status == 2) {
                            return true;
                        }
                        return false;
                    }, forClick: function (data) {
                        userRequest.SetUserStatus(function (d) {
                            if (d.Message == "OK") {
                                store.Table.OnPageChange(store.SearchEntity.PageIndex, window.rootVue)
                                window.rootVue.$message.success(g("$操作成功"))
                            } else {
                                window.rootVue.$message.error(d.Message)
                            }
                        }, data.ID, 1)
                    }
                })

                arr.push({
                    nickName: g('$删除'), buttonType: 'error', type: 'ButtonCheckShow', CheckShow: function (data) {
                        if (data.Status != -1) {
                            return true;
                        }
                        return false;
                    }, forClick: function (data) {
                        userRequest.SetUserStatus(function (d) {
                            if (d.Message == "OK") {
                                store.Table.OnPageChange(store.SearchEntity.PageIndex, window.rootVue)
                                window.rootVue.$message.success(g("$操作成功"))
                            } else {
                                window.rootVue.$message.error(d.Message)
                            }
                        }, data.ID, -1)
                    }
                })

            } else if (IsRights(Modulel.UserManage, Permission.Delete)) {
                arr.push({
                    nickName: g('$删除'), buttonType: 'error', type: 'Button', forClick: function (data) {

                    }
                })
            }
            window.rootVue.$set(store.Table, '$TableRowButtons', arr)
            return store.Table.$TableRowButtons;
        },

        //
        TableIsEdit: true, //是否显示操作列
        PageSize: 50, //每页数量
        PageSizeOpts : [50, 100,200,300], //每页数量
        OnPageChange: function (Index) { //更改页面
            var state = UserManagePage.getThisStore()
            state.SearchEntity.PageIndex = Index;
            state.SearchPageData(window.rootVue);
        },
        OnPageSizeOpts: function (pageSize) { //更改每页显示数
            var state = UserManagePage.getThisStore()
            state.SearchEntity.PageIndex = 1;
            state.SearchEntity.PageSize = pageSize;
            state.SearchPageData(window.rootVue);
        },
    },
    FieldData: [
        {
            nickName: g('$部门'), field: 'DepartmentID', type: 'FunZTreeSelect', error: '', initValue: [], SelectDepartmentValue: [], forValueStoreName: 'SelectDepartmentValue', forSelectStoreName: 'UserManagePage_DepartmentList', initField: function (vueObj, callback, data, field) {
                var vueState = vueObj.$store.state;
                var state = vueObj.$store.state[UserManagePage.storeName];

                function init(d) {
                    var nodes = [];
                    var valuess = [];
                    var i = 0;
                    function bl(p) {
                        var ws = new window.$LQ(d)
                            .Where(function (e) {
                                return (!p && !e.PID) || (p && e.PID == p.ID)
                            })
                            .Select(function (item) {
                                item.label = item.EnName + " " + item.Name
                                item.value = item.ID;
                                return item;
                            }).items;
                        if (!p) {
                            nodes = ws
                            for (var i of nodes) {
                                bl(i)
                            }
                        } else {
                            if (ws.length > 0) {
                                p.children = ws
                                for (var i of p.children) {
                                    bl(i)
                                }
                            }
                        }
                        i++;
                    }
                    bl()

                    function vbl(p) {
                        var ws = new window.$LQ(d)
                            .Where(function (e) {
                                return (!p && e.ID == data.DepartmentID) || (p && e.ID == p)
                            })
                            .FirstOrDefault(function (item) {
                                return item;
                            });
                        valuess.push(ws.ID)
                        if (ws.PID) {
                            vbl(ws.PID)
                        }
                    }
                    vbl()

                    valuess = new window.$LQ(valuess).OrderBy(function (a) {
                        return a + "";
                    }).items

                    valuess = valuess[0] ? valuess : []
                    vueObj.$set(vueState, "UserManagePage_DepartmentList", nodes)
                    vueObj.$set(field, "SelectDepartmentValue", valuess)
                    callback('UserManagePage_DepartmentList', nodes)
                }

                if (field.Data) {
                    init(field.Data)
                } else {
                    departmentSearchRequest.GetDepartmentList(function (d) {
                        vueObj.$set(field, "Data", d)
                        init(d)
                    }, {});
                }

            }, toFieldData: function (field, entity) {
                var vueObj = window.rootVue;
                var vueState = vueObj.$store.state;
                var wsd = new window.$LQ(field['SelectDepartmentValue']).Last()
                vueObj.$set(entity, "DepartmentID", wsd)
                return wsd;
            }
        },
        { nickName: g('$用户编码'), field: 'UserCode', type: 'String', error: '', initValue: '', IsNotEdit: true },
        //{nickName:g('$客户'), field:'OrganizationID',type:'Select',forSelectStoreName:'UserOrganizationID'},
        { nickName: g('$用户类型'), field: 'UserType', type: 'Hide', forSelectStoreName: 'UserType', initValue: 0, IsShowCheck: function () { return false; } },
        //{nickName:g('$状态'), field:'Status',type:'Select',forSelectStoreName:'UserStatus'},
        { nickName: g('$登录名'), field: 'LoginName', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g('${登录名}为必填') }, initValue: '' },
        { nickName: g('$姓'), field: 'FirstName', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g('${姓}为必填') }, initValue: '' },
        { nickName: g('$名'), field: 'LastName', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g('${名}为必填') }, initValue: '' },
        { nickName: g('$密码'), field: 'Password', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g('${密码}为必填') }, initValue: '', IsShowCheck: function (entity, field) { return !entity.ID; } },
        { nickName: g('$Email'), field: 'Email', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g('${Email}为必填') }, initValue: '' },
        {
          nickName: g('$性别'),
            type: 'Col',
            colType: "LineCol",
            colFields: [
                { nickName: g('$性别'), field: 'Gender', type: 'Select', span: 11, error: '', isRequired: true, j: { rex: 'w', tips: g('${性别}为必填') }, initValue: '', forSelectStoreName: 'UserGender' },
                { nickName: g('$生日'), type: 'SplitText', span: 2, isNotField: true },
                { nickName: g('$生日'), field: 'Birthday', type: 'DateTime', span: 11, error: '', isRequired: true, j: { rex: 'w', tips: g('${生日}为必填') }, initValue: '' },
            ]
        },

        { nickName: g('$手机'), field: 'PhoneNumber', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g('${手机}为必填') }, initValue: '' },
        {
            nickName: g('$角色'), field: 'UserRoles', type: 'CheckboxList', error: '', initValue: '', forValueStoreName: 'SelectRoleValue', forSelectStoreName: 'UserManagePage$SelectRole', initField: function (vueObj, callback, data, field) {
                var vueState = vueObj.$store.state;
                var state = vueObj.$store.state[UserManagePage.storeName];

                function init(d) {

                    var ws = new window.$LQ(d.Records)
                        .Select(function (item) {
                            item.Text = item.Name
                            item.Value = item.ID;
                            return item;
                        }).items;
                    var wsd;
                    if (data.UserRoles) {
                        wsd = new window.$LQ(data.UserRoles)
                            .Select(function (item) {
                                return item.RoleID;
                            }).items;
                    } else {
                        wsd = [];
                    }

                    vueObj.$set(vueState, "UserManagePage$SelectRole", ws)
                    vueObj.$set(field, "SelectRoleValue", wsd)
                    if (callback) {
                        callback('UserManagePage$SelectRole', d)
                    }
                }

                if (field.Data) {
                    init(field.Data)
                } else {
                    RoleRequest.SearchRole(function (d) {
                        vueObj.$set(field, "Data", d)
                        init(d)
                    }, {
                            PageIndex: 1,
                            pageSize: 2000,
                        })
                }

            }, toFieldData: function (field, entity) {
                var vueObj = window.rootVue;
                var vueState = vueObj.$store.state;
                var wsd;
                wsd = new window.$LQ(field['SelectRoleValue'])
                    .Select(function (item) {
                        return {
                            RoleID: item,
                            UserID: entity.ID
                        };
                    }).items;
                vueObj.$set(entity, "UserRoles", wsd)
                return wsd;
            }
        },
        // { nickName: g('$最后登录时间'), field: 'LastLoginTime', type: 'DateTime', error: '', initValue: '', IsNotEdit: true },
        // { nickName: g('$登录ip'), field: 'LoginIp', type: 'String', error: '', initValue: '::', IsNotEdit: true },
        // { nickName: g('$密码输入错误次数'), field: 'ErrorLoginNum', error: '', type: 'String', IsNotEdit: true, forSelectStoreName: 'UserErrorLoginNum' },
    ],
    getThisStore: function () {
        var vueObj = window.rootVue;
        var vueState = vueObj.$store.state;
        var state = vueObj.$store.state[UserManagePage.storeName];
        return state;
    },

    initPageData() {
        var store = UserManagePage.getThisStore()
        var vueObj = window.rootVue;

        if (!store || !store.IsInit) {
            store = Clone(UserManagePage);
            store.Entity = ToSubmitData(ToComponentData(UserManagePage.FieldData))
            store.SearchEntity = ToSubmitData(ToComponentData(UserManagePage.Search))
            store.IsInit = true;
            vueObj.$set(vueObj.$store.state, UserManagePage.storeName, store)
            store.SearchPageData();
        }

        return store
    },
    SearchPageData(callback) {
        var vueObj = window.rootVue;
        var vueState = vueObj.$store.state;
        var state = vueObj.$store.state[UserManagePage.storeName];

        if (!state.SearchEntity.PageSize) {
            state.SearchEntity.PageSize = UserManagePage.Table.PageSize
        }

        state.SearchEntity.UserType = 0;
        if (!vueState['SearchUser']) {
            vueObj.$set(vueState, "SearchUser", dc)
        }

        userRequest.SearchUser(function (d) {
            vueObj.$set(vueState, "SearchUser", d)
            state.Table.$TableRowButtons = null;
            window.rootVue.$set(state.Table, '$TableRowButtons', state.Table.TableRowButtons())
            if (callback) {callback(d) }
        }, state.SearchEntity)

        return vueState['SearchUser']
    },

    ResetUserListPassword: function (userIDs,newPassword,callback) {

        userRequest.ResetUserListPassword(function (d) {
            if (d.Message == "OK") {
                if (callback) { callback(d) }
                vueObj.$message.success(g("$操作成功"))
            } else {
                vueObj.$message.error(d.Message)
            }
        }, userIDs, newPassword)

    },


    Update: function (store) {

        if (!store.Entity.ID) { //add
            var entity = ToSubmitEntity(store.Entity, store.FieldData);
            entity.UserType = 0;
            if (CheckByEntity(entity, store.FieldData)) {
                userRequest.AddUser(function (d) {
                    if (d.Message == "OK") {
                        store.AddModuleShow = false;
                        store.Table.OnPageChange(1, window.rootVue)
                        window.rootVue.$message.success(g("$操作成功"))
                    } else {
                        window.rootVue.$message.error(d.Message)
                    }
                }, entity)
            }
        } else { //update
            var entity = ToSubmitEntity(store.Entity, store.FieldData);
            if (CheckByEntity(entity, store.FieldData)) {

                userRequest.UpdateUser(function (d) {
                    if (d.Message == "OK") {
                        store.AddModuleShow = false;
                        window.rootVue.$message.success(g("$操作成功"))
                        store.Table.OnPageChange(1, window.rootVue)
                    } else {
                        window.rootVue.$message.error(d.Message)
                    }
                }, entity)

            }
        }
    },
    AddModuleShow: false,
    AddModalName: g('$新增用户'),
    ToAdd(store) {
        store.AddModuleShow = true;
        store.ModalName = g('$新增用户')
        store.AddModalName = g('$新增用户')
        var Entity = ToSubmitData(ToComponentData(UserManagePage.FieldData))
        var f = new window.$LQ(store.FieldData).Where(function (a) {
            a.error == '';
            return a.field == 'Password'
        }).First()
        f.type = "String"
        f.j = { rex: 'w', tips: g('${密码}为必填') };
        window.rootVue.$set(store, 'Entity', Entity)
    }
}




// WEBPACK FOOTER //
// ./src/config/Sys/userConfig.js